import {Blog, MenuType} from "@/types";
import {categoryDetails as category1}  from "@/content/services/1";
import {categoryDetails as category2}  from "@/content/services/2";
import {blogCategoryDetails as blog1} from "@/content/blogs/1";

export const footerData : MenuType [] = [
    {
        label: 'Sitemap',
        children:[
            // {
            //     label: 'Home',
            //     href: '/',
            // },
            {
                label: 'Services',
                href: '/services',
            },
            {
                label: 'Contact',
                href: '/contact',
            },
            {
                label: 'About',
                href: '/about',
            }
        ]
    },
    {
        label: category1.name,
        href: `/${category1.categoryType}/${category1.slug}`,
        children: [
            ...category1?.subCategories?.length
                        ? category1.subCategories.map((blog: Blog) => ({
                            href: `/${category1.categoryType}/${category1.slug}/${blog.slug}`,
                            label: blog.title,
                        }))
                        : []
        ]
    },
    {
        label: category2.name,
        href: `/${category2.categoryType}/${category2.slug}`,
        children: [
            ...category2?.subCategories?.length
                ? category2.subCategories.map((blog: Blog) => ({
                    href: `/${category2.categoryType}/${category2.slug}/${blog.slug}`,
                    label: blog.title,
                }))
                : []
        ]
    },


    {
        label: blog1.name,
        href: `/${blog1.categoryType}/${blog1.slug}`,
        children: [
                ...blog1?.blogs?.length
                        ? blog1.blogs.map((blog: Blog) => ({
                            href: `/${blog1.categoryType}/${blog1.slug}/${blog.slug}`,
                            label: blog.title,
                        }))
                        : []
            ]
    },
    {
        label: 'Contact us',
        href: '/contact',
    },
    // {
    //     label: 'About',
    //     href: '/about',
    // }
]
